import { render, staticRenderFns } from "./UnreadMessages.vue?vue&type=template&id=dae027bc&"
import script from "./UnreadMessages.vue?vue&type=script&lang=js&"
export * from "./UnreadMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports